import React from 'react';
import { Table } from 'antd';
import { DashboardPrimaryActionButton } from '../components/dashboard';
import { renderMaintTag, renderServiceTag } from './statusTags';

export default function ForkliftDesktopTable({
  forklifts,
  loading,
  navigate,
  selectedRowId,
  setSelectedRowId,
}) {
  const tableColumns = [
    {
      title: 'Unit ID',
      dataIndex: 'unitId',
      key: 'unitId',
      fixed: 'left',
      render: (text, record) =>
        text ? (
          <DashboardPrimaryActionButton
            type="link"
            className="customer-preview-unit-link"
            onClick={() =>
              navigate(
                `/customer/maintenance?unitId=${encodeURIComponent(record.unitId)}`
              )
            }
          >
            {text}
          </DashboardPrimaryActionButton>
        ) : (
          '—'
        ),
    },
    { title: 'Make', dataIndex: 'make', key: 'make' },
    { title: 'Model', dataIndex: 'model', key: 'model' },
    { title: 'Serial #', dataIndex: 'serialNumber', key: 'serialNumber' },
    {
      title: 'Hours',
      dataIndex: 'hourMeter',
      key: 'hourMeter',
      render: (value) => (value || value === 0 ? value : '—'),
    },
    {
      title: 'Fleet status',
      key: 'service',
      render: (_, record) => renderServiceTag(record.status),
    },
    {
      title: 'Maintenance',
      key: 'maintenance',
      render: (_, record) => renderMaintTag(record.maintenanceStatus),
    },
  ];

  return (
    <Table
      dataSource={forklifts}
      columns={tableColumns}
      rowKey="id"
      loading={loading}
      pagination={false}
      size="middle"
      rowClassName={(record) =>
        record.id === selectedRowId ? 'ant-table-row-selected' : ''
      }
      onRow={(record) => ({ onClick: () => setSelectedRowId(record.id) })}
      scroll={{ x: 'max-content' }}
    />
  );
}
